import { type } from '../actions/type';


const INITIAL_STATE = {
    cData: null,
    uData:null ,
    search:null,
}

const campaignReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case type.CAMPAIGN_SEARCH:

            return { ...state, search: action.payload.campaignSearch  };

        case type.CAMPAIGN_RESULT:
            return { ...state, cData: action.payload.campaignData, uData: action.payload.userData }

        default:
            return state;
    }
}
export default campaignReducer;